import { FC } from 'react';

import LoginView from './components/LoginView/LoginView';
import useLogin from './hooks/useLogin';
import { LoginPageStyled } from './LoginPage.styled';

const LoginPage: FC = () => {
  const { redirectToCognitoLoginPage, redirectToCognitoForgotPasswordPage, isLoginLoading } =
    useLogin();

  return (
    <LoginPageStyled>
      <LoginView
        isLoginLoading={isLoginLoading}
        onLoginClick={redirectToCognitoLoginPage}
        onForgotPasswordClick={redirectToCognitoForgotPasswordPage}
      ></LoginView>
    </LoginPageStyled>
  );
};

export default LoginPage;
